import { createFileRoute } from '@tanstack/react-router';
import { NotaFiscalServicoListagem } from '@/features/nfse/page/listagem/NotaFiscalServicoListagem';

export const Route = createFileRoute('/a/nfse/')({
    component: NotaFiscalServicoListagem,
});
